import { render } from "./login-app.vue?vue&type=template&id=ddaade16&scoped=true"
import script from "./login-app.vue?vue&type=script&lang=js"
export * from "./login-app.vue?vue&type=script&lang=js"

import "./login-app.vue?vue&type=style&index=0&id=ddaade16&scoped=true&lang=css"

import exportComponent from "C:\\IDLS\\Repos\\web\\IDLS.CustomerPortal\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ddaade16"],['__file',"wwwroot/app/login/login-app.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ddaade16"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ddaade16', __exports__)) {
    api.reload('ddaade16', __exports__)
  }
  
  module.hot.accept("./login-app.vue?vue&type=template&id=ddaade16&scoped=true", () => {
    api.rerender('ddaade16', render)
  })

}


export default __exports__